var _excluded = ["desc", "focusable", "title", "iconName", "className"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from 'react';
import { string, bool } from 'prop-types';
import classNames from 'classnames';
var svg = /*#__PURE__*/React.createElement("svg", {
  viewBox: "0 0 32 32"
}, /*#__PURE__*/React.createElement("path", {
  d: "M28.985 8v16h-26V8h26m0-1h-26a1 1 0 00-1 1v16a1 1 0 001 1h26a1 1 0 001-1V8a1 1 0 00-1-1z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12.32 16.818h-1.67a.162.162 0 01-.163-.16v-.565a.162.162 0 01.16-.163h1.312l-.84-2.064a.266.266 0 00-.225-.154l-1.579.005a.476.476 0 00-.282.115l-3.938 3.726c-.067.062-.12.038-.12-.053l-.005-.912a.411.411 0 01.12-.274l3.66-3.423a.47.47 0 01.283-.11h2.507a.258.258 0 01.225.154l2.11 5.276a.239.239 0 00.191.148.153.153 0 00.13-.168v-4.638a.162.162 0 01.16-.163h.634a.162.162 0 01.163.16v2.466c0 .091.052.11.115.048l3.21-3.169a.463.463 0 01.278-.115h8.081a.162.162 0 01.163.16v.564a.162.162 0 01-.16.164h-5.08a.162.162 0 00-.162.16v.003l.005 5.204a.162.162 0 01-.16.163h-.592a.162.162 0 01-.162-.16v-.002l-.005-5.185a.162.162 0 00-.16-.163h-1.38a.45.45 0 00-.278.115l-2.158 2.228a.172.172 0 000 .235l2.727 2.823c.062.062.038.12-.048.12h-.808a.43.43 0 01-.278-.12l-2.148-2.271a.15.15 0 00-.213-.012l-.012.012-.67.691a.468.468 0 00-.115.284l.005 1.253a.162.162 0 01-.16.163h-.003l-1.53-.01a.258.258 0 01-.226-.154z"
}));

var Icon = function Icon(_ref) {
  var desc = _ref.desc,
      _ref$focusable = _ref.focusable,
      focusable = _ref$focusable === void 0 ? false : _ref$focusable,
      title = _ref.title,
      iconName = _ref.iconName,
      className = _ref.className,
      rest = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    focusable: String(focusable),
    className: classNames('rds-svg--ticket-akt-outline-icon', className)
  }, rest, svg.props), title && /*#__PURE__*/React.createElement("title", null, title), desc && /*#__PURE__*/React.createElement("desc", null, desc), svg.props.children);
};

Icon.propTypes = {
  desc: string,
  focusable: bool,
  title: string,
  iconName: string,
  className: string
};
Icon.displayName = 'TicketAktOutlineIcon';
export default Icon;